import request from '../utils/request.js'

// 查询新闻列表
export function newsList(data) {
  // console.log(data)
  return request({
    url: '/web/api/news/list',
    method: 'get',
    params:data
  })
}


export function newsDetail(data) {
  // console.log(data)
  return request({
    url: '/web/api/news/detail/' + data,
    method: 'get'
  })
}
